import dynamic from 'next/dynamic'
import React from 'react'

// Dynamic import với SSR disabled để tránh lỗi build
const Lottie = dynamic(() => import('react-lottie'), { ssr: false })

interface LottieWrapperProps {
  options: {
    loop?: boolean
    autoplay?: boolean
    animationData: any
    rendererSettings?: {
      preserveAspectRatio?: string
    }
  }
  height?: number | string
  width?: number | string
}

export const LottieWrapper: React.FC<LottieWrapperProps> = ({ options, height, width }) => {
  return <Lottie options={options} height={height} width={width} />
}
